module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/182-niue-478238d1236580078ca1bb8b6b98c694.svg";